import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getDefectActWorkGuaranteeAvailableColumns } from './api';

export const path = '/defect-act-work-guarantee/list';

const PageDefectActWorkGuaranteeList: React.FC = (props) => {
  const DefectActWorkGuarantee = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getDefectActWorkGuaranteeAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <DefectActWorkGuarantee {...props} />;
};

export default PageDefectActWorkGuaranteeList;
